import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  ExternalDataService,
  PartnerDto,
  PartnerInvoiceDto,
} from '../../../services/externalDataService.service';

@Component({
  selector: 'app-partner-invoices-grid',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './partner-invoices-grid.component.html',
  styleUrl: './partner-invoices-grid.component.css',
})
export class PartnerInvoicesGridComponent implements OnChanges {
  @Input() partners: PartnerDto[] = [];

  selectedPartnerId = '';
  manualPartnerId = '';
  invoices: PartnerInvoiceDto[] = [];
  loading = false;
  errorMessage = '';

  constructor(private externalData: ExternalDataService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['partners'] && this.partners?.length && !this.selectedPartnerId) {
      this.selectedPartnerId = this.partners[0].id;
    }
  }

  private effectivePartnerId(): string {
    if (this.partners.length) {
      return (this.selectedPartnerId || '').trim();
    }
    return this.manualPartnerId.trim();
  }

  /** Comma-separated list for display (full text; wrapping handled in CSS). */
  referencesText(refs: string[] | null): string {
    if (!refs?.length) return '—';
    return refs.join(', ');
  }

  loadInvoices(): void {
    this.errorMessage = '';
    this.invoices = [];
    const pid = this.effectivePartnerId();
    if (!pid) {
      this.errorMessage = 'Select a partner or enter a partner ID.';
      return;
    }

    this.loading = true;
    this.externalData.getPartnerInvoices(pid).subscribe({
      next: (rows) => {
        this.invoices = rows ?? [];
        this.loading = false;
      },
      error: (error) => {
        console.error('getPartnerInvoices', error);
        const body = error?.error;
        this.errorMessage =
          body?.detail ||
          body?.title ||
          'Could not load invoices. Please try again.';
        this.loading = false;
        this.invoices = [];
      },
    });
  }

}
